export default __webpack_public_path__ + "static/games-ba446d432a58d207a8303d624a958ae6.png";